export enum EUsersUrls {
  USERS = 'users',
  RESEND_INVITATION = 'resend-invitation',
  VALIDATE = 'validate',
}
